import React from "react";
import { Link } from "react-router-dom";

// FONTAWESOME
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default function AYMenu({ serviceLinks, treatmentLinks }) {
  function onLinkClick() {
    let MobileMenuDropDown = document.getElementById("menu");
    let MobileMenuBtn = document.querySelector(".btn-show-menu-mobile");

    if (MobileMenuBtn?.classList?.contains("is-active")) {
      MobileMenuBtn.classList.remove("is-active");
    }

    if (MobileMenuDropDown?.classList?.contains("show")) {
      MobileMenuDropDown.classList.remove("show");
    }
  }

  function triggerMobileSubMenu(e) {
    // Find the closest <li> element
    const li = e.currentTarget.closest("li");
    const dropDownIcon = e.currentTarget.closest("svg");
    if (!li) return;
    // console.log(dropDownIcon);

    // Find its child .mega-submenu
    const submenu = li.querySelector(".mega-submenu");
    if (submenu) {
      submenu.classList.toggle("active"); // toggle class to show/hide submenu
    }
    if (dropDownIcon) {
      dropDownIcon?.classList.toggle("mobileMenuDropDownRotate");
    }
  }

  return (
    <ul className="menu">
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/about">
          About
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/services">
          Services
        </Link>
        <FontAwesomeIcon
          className="mobileMenuDropDown"
          onClick={triggerMobileSubMenu}
          icon={faChevronDown}
        />
        <ul className="mega-submenu">
          {/* FINALISED MENU */}
          {serviceLinks && serviceLinks.length > 0
            ? serviceLinks.map((item, index) => {
                return (
                  <li key={index}>
                    <Link onClick={onLinkClick} to={`${item.url}`}>
                      {item.name}
                    </Link>
                  </li>
                );
              })
            : null}
        </ul>
      </li>
      <li className="mega-menu-item menu-hover-custom">
        <Link onClick={onLinkClick} to="/USHAKriya-Wellness">
          Yoga
        </Link>
      </li>
      <li className="mega-menu-item">
        <a>Treatment</a>
        <FontAwesomeIcon
          className="mobileMenuDropDown"
          onClick={triggerMobileSubMenu}
          icon={faChevronDown}
        />
        <ul className="mega-submenu">
          {treatmentLinks && treatmentLinks.length > 0
            ? treatmentLinks.map((item, index) => {
                return (
                  <li key={`${index}-treatment`}>
                    <Link onClick={onLinkClick} to={`${item.url}`}>
                      {item.name}
                    </Link>
                  </li>
                );
              })
            : null}
        </ul>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/Centers-and-Camps">
          Centers & Camps
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/shop">
          Shop
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/team">
          Dhara Parivar
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/blog">
          Feedback & News
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/contact">
          Contact
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/login">
          Register/Login
        </Link>
      </li>
    </ul>
  );
}
